module.exports = __webpack_public_path__ + "static/media/logo-agilelab.6dd8cb78.png";